const TOKEN_KEY = "token";

export const getToken = () => localStorage.getItem(TOKEN_KEY) ?? "";

export const setToken = (token: string) => {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
  } else {
    localStorage.removeItem(TOKEN_KEY);
  }
};
